import { EncryptStorage } from 'encrypt-storage'

export const encryptedStorage = new EncryptStorage(
  process.env.REACT_APP_STORAGE_KEY,
  {
    prefix: '@myapp',
    storageType: 'sessionStorage', // o 'localStorage'
  }
)
